import { updateState, withDevtools, withFeatureFactory } from '@angular-architects/ngrx-toolkit';
import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setPageNumber, setPageSize, withPagination, withPaginationMethods } from '@shared/state/pagination.feature';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { pipe, switchMap, tap } from 'rxjs';
import { User } from '../../../../shared/data-access/data-access-authentication';
import { FilterUserRequest } from '../model/user-filter-request.mode';
import { UserService } from '../services/user.service';

export const UserStore = signalStore(
  withDevtools('admin-reports'),
  withState({
    data: null as User[] | null,
  }),
  withRequestStatus(),
  withFeatureFactory((store) => withPagination<User>(store.data)),
  withComputed(({ data }) => ({
    users: computed(() => data()),
  })),
  withMethods((store, userService = inject(UserService)) => ({
    load: rxMethod<FilterUserRequest>(
      pipe(
        tap(({ pageNumber, pageSize, enableGlobalLoader }) => {
          if (!enableGlobalLoader) {
            updateState(store, '[UserStore] Set pending', setPending());
          }
          updateState(store, '[UserStore] Set page number', setPageNumber(pageNumber));
          updateState(store, '[UserStore] Set page size', setPageSize(pageSize));
        }),
        switchMap(({ search, enableGlobalLoader }) =>
          userService
            .getUsers({ search, pageSize: store.pageSize(), pageNumber: store.pageNumber(), enableGlobalLoader })
            .pipe(
              tapResponse({
                next: (data) => {
                  updateState(store, '[UserStore] Set fulfilled', setFulfilled());
                  updateState(store, '[UserStore] Set data', { data });
                },
                error: () => {
                  updateState(store, '[UserStore] Set error', setError());
                  updateState(store, '[UserStore] Set data', { data: null });
                },
              }),
            ),
        ),
      ),
    ),
  })),
  withFeatureFactory((store) => withPaginationMethods(store)),
);
